const blockHero = (Swiper, Navigation, Pagination, Autoplay) => {
	let swiperHero = document.querySelector('.s-hero__swiper');
	const paths = document.querySelectorAll('.c-swiper-single-arrow__path-hero');

	if (swiperHero) {
		swiperHero = new Swiper('.s-hero__swiper', {
			modules: [Navigation, Pagination, Autoplay],
			loop: true,
			slidesPerView: 1,
			speed: 1000,
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
			},
			navigation: {
				nextEl: '.c-swiper-single-arrow--hero.c-swiper-single-arrow--next',
				prevEl: '.c-swiper-single-arrow--hero.c-swiper-single-arrow--prev',
			},
		});
	}

	if (paths && swiperHero) {
		swiperHero.on('slideChange', () => {
			const indexCurrentSlide = swiperHero.activeIndex;
			const currentSlide = swiperHero.slides[indexCurrentSlide];

			if (currentSlide.classList.contains('type-arrow-dark')) {
				paths.forEach((el) => el.classList.add('c-swiper-single-arrow__path-hero--v2'));
			} else if (currentSlide.classList.contains('type-arrow-white')) {
				paths.forEach((el) => el.classList.remove('c-swiper-single-arrow__path-hero--v2'));
			}
		});
	}
};
export default blockHero;
